module.exports = __webpack_public_path__ + "img/tokyo.dd04a345.jpg";